module.exports = __webpack_public_path__ + "static/img/thHy.57de5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thHy.png
// module id = a13U
// module chunks = 0